// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"5139b0e3","53":"a9798386","406":"05f46e40","455":"f32529e2","489":"8e1516f3","873":"ce47742b","977":"670b9fab"}[chunkId] + ".chunk.js";
};